import { defineMessage } from "react-intl";

// ------ Defaults ------
export const requiredMessage = defineMessage({
  id: "form.validation.mixed.required",
  defaultMessage: "Required",
});

// ------ String ------
export const emailMessage = defineMessage({
  id: "form.validation.string.email",
  defaultMessage: "Invalid email address",
});

export const stringMinMessage = defineMessage({
  id: "form.validation.string.min",
  defaultMessage:
    "Must be at least {min} {min, plural, one {character} other {characters}}",
});

export const stringMaxMessage = defineMessage({
  id: "form.validation.string.max",
  defaultMessage:
    "Cannot be more than {max} {max, plural, one {character} other {characters}}",
});

export const stringLengthMessage = defineMessage({
  id: "form.validation.string.length",
  defaultMessage:
    "Must be {length} {length, plural, one {character} other {characters}}",
});

export const specialCharMessage = defineMessage({
  id: "form.validation.password.specialChar",
  defaultMessage: "Must contain at least one special character",
});

export const singleNumberMessage = defineMessage({
  id: "form.validation.password.number",
  defaultMessage: "Must contain at least one number",
});

export const lowercaseCharMessage = defineMessage({
  id: "form.validation.password.lowercase",
  defaultMessage: "Must contain at least one lowercase",
});

// ------ Numbers ------
export const positiveMessage = defineMessage({
  id: "form.validation.number.positive",
  defaultMessage: "Must be positive",
});

export const greaterThanZeroMessage = defineMessage({
  id: "form.validation.number.greaterThanZero",
  defaultMessage: "Must be greater than zero",
});

export const integerMessage = defineMessage({
  id: "form.validation.number.integer",
  defaultMessage: "Must be a whole number",
});

export const numberMessage = defineMessage({
  id: "form.validation.number.default",
  defaultMessage: "Must be a valid number",
});

// ------ Dates ------
export const validDateMessage = defineMessage({
  id: "form.validation.date.valid",
  defaultMessage: "Must be a valid date",
});

export const validDobMessage = defineMessage({
  id: "form.validation.date.dob",
  defaultMessage: "Must be a valid date of birth",
});

// ------ End of message definitions ------

export const validationMessages = {
  mixed: {
    required: requiredMessage,
  },
  number: {
    integer: integerMessage,
    positive: positiveMessage,
    greaterThanZero: greaterThanZeroMessage,
    default: numberMessage,
  },
  string: {
    email: emailMessage,
    lowercaseChar: lowercaseCharMessage,
    min: stringMinMessage,
    max: stringMaxMessage,
    length: stringLengthMessage,
    singleNumber: singleNumberMessage,
    specialChar: specialCharMessage,
  },
  date: {
    valid: validDateMessage,
    dob: validDobMessage,
  },
};
